export default __webpack_public_path__ + "static/media/css3.b3c0acbf.svg";